import { createApp, Plugin } from 'vue';

const Notifier: Plugin = {
    install(app, options) {
    app.config.globalProperties.$notifier = {
    confirm: (msg: string, onYesClicked?: Function) => {
        options.store.commit('notificationDialog/showMessage', {type: 'delete', title: 'Delete', msg, onYesClicked});
},
}
}
}

export default Notifier;

